import { createResourceAtom } from 'lib/atoms';
import { buildSectionMutationAtom } from 'lib/atoms/section-mutation';
import type { FinancialSummaryResponse } from '../types-financial-summary';

// Read-only section: a resource atom for the read + confirm/revert mutation
// atoms for Mark-as-Correct / Remove Correct Status (no edit atom).
export const createFinancialSummaryResourceAtom = (href: string | undefined) =>
  createResourceAtom<FinancialSummaryResponse>(href);

export const financialSummaryUrl = (documentId: number | string) =>
  `/documents/${documentId}/royalty_check_structuring/financial_summary`;

export const confirmFinancialSummaryAtom =
  buildSectionMutationAtom<FinancialSummaryResponse>();
export const revertFinancialSummaryAtom =
  buildSectionMutationAtom<FinancialSummaryResponse>();
